import { createApp } from 'vue'
import router from './router'
import App from './App.vue'
import { createPinia } from 'pinia'
import 'v-calendar/dist/style.css'
import VCalendar from 'v-calendar'
import { useUserStore } from './stores/userStore'
import { i18n } from './i18n'
import { initializeOAuthService } from './services/oauthService'
import { getToken } from './services/tokenService'

const app = createApp(App)
const pinia = createPinia()

// Initialize v-calendar before pinia
app.use(VCalendar, {
  componentPrefix: 'v'
})
app.use(pinia)
app.use(router)
app.use(i18n)

const userStore = useUserStore()

// Initialize language from localStorage or default to Norwegian
const savedLanguage = localStorage.getItem('userLanguage')
if (savedLanguage && (savedLanguage === 'no' || savedLanguage === 'en')) {
  i18n.global.locale.value = savedLanguage
}

// Initialize token based on login state
const initializeToken = async () => {
  if (userStore.isLoggedIn) {
    try {
      await getToken(false)  // Get CRM token for logged in user
      userStore.resetInactivityTimeout()
    } catch (error) {
      console.error('Failed to restore CRM token:', error)
      userStore.logout()
      initializeOAuthService()  // Fallback to public token
    }
  } else {
    initializeOAuthService()  // Get public token for non-logged in users
  }
}

initializeToken()
app.mount('#app')
